import { render, staticRenderFns } from "./Application.vue?vue&type=template&id=6405126b&scoped=true&"
var script = {}
import style0 from "./Application.vue?vue&type=style&index=0&id=6405126b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6405126b",
  null
  
)

export default component.exports